import { render, staticRenderFns } from "./LinkMenuLink.vue?vue&type=template&id=09e87faa&scoped=true&"
import script from "./LinkMenuLink.vue?vue&type=script&lang=ts&"
export * from "./LinkMenuLink.vue?vue&type=script&lang=ts&"
import style0 from "./LinkMenuLink.vue?vue&type=style&index=0&id=09e87faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e87faa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VItem,VTooltip})
